import { render, staticRenderFns } from "./DiscussionFilter.vue?vue&type=template&id=20fdd2c9&"
import script from "./DiscussionFilter.vue?vue&type=script&lang=js&"
export * from "./DiscussionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports